import { useEffect, useState } from "react";
import BlogItem from "./BlogItem";

export default function Blog() {
  const [Blogs, setBlogs] = useState<object[]>([]);

  useEffect(() => {
    const api: string =
      "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@asifurrahaman754";

    const fetchBlogs = async () => {
      const response = await fetch(api);
      const data = await response.json();
      setBlogs(data.items);
    };
    fetchBlogs();
  }, []);

  return (
    <div className="max-w-3xl mx-auto mb-20 px-4">
      <h3 className="font-bold text-lg sm:text-xl mb-12 dark:text-white">
        Blogs{" "}
        <span className="text-xs font-medium text-subText dark:text-dark_text">
          I write sometimes
        </span>
      </h3>

      {Blogs.map((item: any) => (
        <BlogItem key={item.guid} blogItem={item} />
      ))}
      <hr className="mt-5" style={{ color: "#f1f1f1" }} />
    </div>
  );
}
